import { TEltFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

interface IHasChanges {
  initialData: TEltFormData
  dataForSave: TEltFormData
  stepContent: (keyof TEltFormData)[]
}

export const hasChanges = ({ initialData, dataForSave, stepContent }: IHasChanges) => {
  return stepContent.some((cur) => {
    return JSON.stringify(initialData[cur]) !== JSON.stringify(dataForSave[cur])
  })
}
